module.exports = __webpack_public_path__ + "static/media/pleasure.655d39e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/pleasure.png
// module id = 493
// module chunks = 0